<!-- <div class="error-404-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="notfound">
                    <div class="notfound-bg">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <h1>Oops!</h1>
                    <h3>Error 404 : Page Not Found</h3>
                    <p>The page you are looking for might have been removed had its name changed or is temporarily unavailable.</p>
                    <a routerLink="/" class="default-btn">Back Home</a>
                </div>
            </div>
        </div>
    </div>
</div> -->
<!-- Start 404 Error Area -->
<section class="error-404-area upper-margin">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="notfound" *ngFor="let Content of errorContent;">
                    <img [src]="Content.img" alt="image">
                    <h3>{{Content.title}}</h3>
                    <p>{{Content.paragraph}}</p>
                    <a routerLink="/" class="default-btn"> BACK TO HOMEPAGE</a>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End 404 Error Area -->
